import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "json-manager" }
const _hoisted_2 = {
  key: 1,
  class: "upload-section"
}
const _hoisted_3 = { class: "upload-form" }
const _hoisted_4 = {
  key: 0,
  class: "drop-message"
}
const _hoisted_5 = {
  key: 1,
  class: "file-preview"
}
const _hoisted_6 = { class: "file-info" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JsonViewer = _resolveComponent("JsonViewer")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("h1", null, "JSONファイル管理", -1)),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['message', _ctx.messageType])
        }, _toDisplayString(_ctx.message), 3))
      : _createCommentVNode("", true),
    (_ctx.currentView === 'upload')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("h2", null, "JSONファイルをアップロード", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              type: "file",
              ref: "jsonInput",
              accept: ".json",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
              hidden: ""
            }, null, 544),
            _createElementVNode("div", {
              class: "dropzone",
              onDrop: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args))),
              onDragover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDragover && _ctx.handleDragover(...args))),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openFileDialog && _ctx.openFileDialog(...args)))
            }, [
              (!_ctx.selectedFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "icon" }, "📄", -1),
                    _createElementVNode("p", null, "Drop your JSON file here or click to browse", -1),
                    _createElementVNode("small", null, "Supports .json files only", -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[7] || (_cache[7] = _createElementVNode("i", { class: "icon" }, "📄", -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedFile.name), 1),
                      _createElementVNode("small", null, _toDisplayString(_ctx.formatFileSize(_ctx.selectedFile.size)), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearFile && _ctx.clearFile(...args)), ["stop"])),
                      class: "clear-btn"
                    }, "✕")
                  ]))
            ], 32),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                disabled: !_ctx.selectedFile || _ctx.uploading,
                class: "btn btn-primary"
              }, _toDisplayString(_ctx.uploading ? 'Uploading...' : 'Upload JSON'), 9, _hoisted_8)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentView === 'viewer')
      ? (_openBlock(), _createBlock(_component_JsonViewer, {
          key: 2,
          "json-data": _ctx.jsonData,
          "file-stats": _ctx.fileStats,
          loading: _ctx.loading,
          error: _ctx.error,
          onReplace: _ctx.handleReplace,
          onMessage: _ctx.showMessage
        }, null, 8, ["json-data", "file-stats", "loading", "error", "onReplace", "onMessage"]))
      : _createCommentVNode("", true)
  ]))
}